import React from "react";
import { Link } from "react-router-dom";
import "./homeHV.css";
import logo from "../../assets/logo.png";

export default function HomeHV() {
  return (
    <main className="home">
      {/* DIGITAL TRANSFORMATION DAY BANNER — Ngày Chuyển đổi số quốc gia 10/10 */}
      <div className="lib-alert-banner">
        <span className="lib-alert-banner__flag">🌐</span>
        <span className="lib-alert-banner__text">
          Hưởng ứng <strong>Ngày Chuyển đổi số quốc gia 10/10</strong> —
          “Chuyển đổi số – Kiến tạo tương lai”
        </span>
        <Link to="/chuyen-doi-so" className="lib-alert-banner__btn">
          Xem trang kỷ niệm →
        </Link>
      </div>

      {/* HERO */}
      <section className="hero">
        <div className="hero__bg" />
        <div className="hero__content container">
          <div className="hero__left">
            <div className="badge">Hệ thống Y tế Hùng Vương Gia Lai</div>
            <h1>
              Chăm sóc sức khỏe <span className="grad">thân thiện</span>,{" "}
              <span className="grad">chuyên nghiệp</span>,{" "}
              <span className="grad">chu đáo</span>.
            </h1>
            <p className="lead">
              Cổng quản trị thống nhất — theo dõi lịch khám, nhân lực, báo cáo và
              vận hành phòng khám nhanh chóng, trực quan.
            </p>

            <div className="hero__actions">
              <Link to="/lich-kham" className="btn primary">
                ➤ Vào lịch khám
              </Link>
              <a href="#" className="btn ghost">
                Xem hướng dẫn
              </a>
            </div>

            <div className="hero__stats">
              <div className="stat">
                <div className="stat__num">12</div>
                <div className="stat__label">Phòng khám</div>
              </div>
              <div className="stat">
                <div className="stat__num">58</div>
                <div className="stat__label">Bác sĩ</div>
              </div>
              <div className="stat">
                <div className="stat__num">96%</div>
                <div className="stat__label">Mức hài lòng</div>
              </div>
            </div>
          </div>

          <div className="hero__right">
            <div className="glass">
              <img src={logo} alt="Logo" />
              <div className="glass__title">Bảng điều khiển</div>
              <ul className="glass__list">
                   <li><Link to="/lich-kham" className="home-link">• Lịch khám theo tuần</Link></li>
    <li><Link to="/lich-kham-tv" className="home-link">• Lịch khám TV</Link></li>
                <li>• Phân ca bác sĩ & điều dưỡng</li>
                <li>• Báo cáo tổng hợp / chi tiết</li>
                <li>• Quản lý phòng khám</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* QUICK ACTIONS */}
      <section className="container section">
        <h2 className="section__title">Tác vụ nhanh</h2>
        <div className="quick">
          <Link to="/lich-kham" className="qcard">
            <div className="qicon">📅</div>
            <div className="qtitle">Lịch khám</div>
            <div className="qdesc">Tạo & quản lý lịch theo ngày/tuần</div>
          </Link>
          <a href="#" className="qcard">
            <div className="qicon">👩‍⚕️</div>
            <div className="qtitle">Nhân lực</div>
            <div className="qdesc">Bác sĩ, điều dưỡng, phân công</div>
          </a>
          <a href="#" className="qcard">
            <div className="qicon">📊</div>
            <div className="qtitle">Báo cáo</div>
            <div className="qdesc">Tổng hợp & thống kê chi tiết</div>
          </a>
          <a href="#" className="qcard">
            <div className="qicon">🏥</div>
            <div className="qtitle">Quản lý phòng</div>
            <div className="qdesc">Cấu hình & sơ đồ phòng khám</div>
          </a>
        </div>
      </section>

      {/* ANNOUNCEMENTS + SHORTCUT BANNER */}
      <section className="container grid2 section">
        <div className="card announcements">
          <div className="card__head">
            <h3>Thông báo nội bộ</h3>
            <a href="#">Xem tất cả</a>
          </div>
          <ul className="ann-list">
            <li>
              <span className="tag tag--info">Mới</span>
              Cập nhật giao diện Lịch khám & popup xác nhận chèn lịch.
              <span className="time">Hôm nay • 08:20</span>
            </li>
            <li>
              <span className="tag tag--warn">Lịch</span>
              Tuần này ưu tiên phòng Nội tổng quát — bổ sung slot chiều.
              <span className="time">Hôm qua • 16:40</span>
            </li>
            <li>
              <span className="tag tag--ok">CSCL</span>
              Xuất báo cáo tháng 10: tỷ lệ hoàn thành 98%.
              <span className="time">2 ngày trước</span>
            </li>
          </ul>
        </div>

        <div className="shortcut card">
          <div className="shortcut__body">
            <div>
              <h3>Đi tới Lịch khám ngay</h3>
              <p>
                Tạo lịch mới, đánh dấu “Nghỉ/Chưa đăng kí”, chèn lịch và xem
                tổng quan theo phòng chỉ với 1 cú nhấp.
              </p>
            </div>
            <Link to="/lich-kham" className="btn primary big">
              Mở lịch khám
            </Link>
          </div>
          <div className="shortcut__bg" />
        </div>
      </section>

      {/* FOOTER MINI */}
      <footer className="footer">
        <div className="container footer__row">
          <div>© {new Date().getFullYear()} Hệ thống Y tế Hùng Vương </div>
          <div className="footer__links">
            <a href="#">Điều khoản</a>
            <a href="#">Bảo mật</a>
            <a href="#">Hỗ trợ</a>
              <a href="https://www.facebook.com/binzet.18">LeAnhQuan</a>
          </div>
        </div>
      </footer>
    </main>
  );
}
